import { render } from "./UpdateElement.vue?vue&type=template&id=611a56fa&scoped=true"
import script from "./UpdateElement.vue?vue&type=script&lang=js"
export * from "./UpdateElement.vue?vue&type=script&lang=js"

import "./UpdateElement.vue?vue&type=style&index=0&id=611a56fa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611a56fa"]])

export default __exports__